import trackEvent from "@analytics/utils/trackEvent";

const PortfolioAnalyticsService = {
  addToTechnology: (name: string, id: string, numberOfCompanies: number, numberOfContacts: number): void => {
    trackEvent("Added to Technology", {
      id,
      name,
      number_of_companies: numberOfCompanies,
      number_of_contacts: numberOfContacts,
    });
  },
  archiveTechnology: (id: string, name: string): void => {
    trackEvent("Technology Archived", {
      id,
      name,
    });
  },
  createTechnology: (name: string, id: string, numberOfCompanies: number, numberOfContacts: number): void => {
    trackEvent("Technology Created", {
      id,
      name,
      number_of_companies: numberOfCompanies,
      number_of_contacts: numberOfContacts,
    });
  },
  initiateSmartSearchFromTechnology: (id: string, name: string, description: null | string | undefined): void => {
    trackEvent("Initiate SmartSearch from Technology", {
      description,
      id,
      name,
    });
  },
  updateTechnology: (id: string, name: string, description: null | string | undefined): void => {
    trackEvent("Technology Details Updated", {
      description,
      id,
      name,
    });
  },
} as const;

export default PortfolioAnalyticsService;
